import Vue from 'vue';
import {Prop, Component} from 'vue-property-decorator'

@Component
class BMIBAvatarWidget extends Vue {
  @Prop({ default: null, type: [String] })
  src: string;

  @Prop({ default: '', type: [String] })
  initials: string;

  @Prop({ default: 'primary', type: [String] })
  bgcolor: string;

  get lblSetting () {
    return {
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/generic-labels').default
    }
  }
}

export default BMIBAvatarWidget



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-ib-avatar-widget/index.ts